<template>
  <div class="swiper-area program-list program">
    <div class="swiper-header mob-column">
      <div class="left-area w100">
        <div
          class="tit-area program title--hover"
          @click="goCenter()"
        >
          <p class="tit">수리과학정보체험센터</p>
        </div>
      </div>
      <div class="right-area pl0 pb0">
        <div class="custom-label">
          <!-- [SP20240202]수리과학 명칭 변경 -->
          <span
            :ref="$constant.CENTER_OID_OBJECT.AREA0000001.KEY"
            class="label"
            :class="$constant.CENTER_OID_OBJECT.AREA0000001.KEY === checkedCenterOid ? 'is-checked' : '' "
            @click="changeSelectCenter($constant.CENTER_OID_OBJECT.AREA0000001.KEY)"
          >
            제 1센터(원주)
          </span>
          <span
            :ref="$constant.CENTER_OID_OBJECT.AREA0000002.KEY"
            class="label"
            :class="$constant.CENTER_OID_OBJECT.AREA0000002.KEY === checkedCenterOid ? 'is-checked' : '' "
            @click="changeSelectCenter($constant.CENTER_OID_OBJECT.AREA0000002.KEY)"
          >
            제 2센터(춘천)
          </span>
          <span
            :ref="$constant.CENTER_OID_OBJECT.AREA0000003.KEY"
            class="label"
            :class="$constant.CENTER_OID_OBJECT.AREA0000003.KEY === checkedCenterOid ? 'is-checked' : '' "
            @click="changeSelectCenter($constant.CENTER_OID_OBJECT.AREA0000003.KEY)"
          >
            제 3센터(동해)
          </span>
        </div>
      </div>
    </div>
    <!-- body -->
    <div class="swiper-body">
      <div class="control-bar">
        <div class="swiper-button-prev swiper-program-prev" slot="button-prev">
          <span class="material-icons">arrow_back_ios</span>
        </div>
        <div class="swiper-button-next swiper-program-next" slot="button-next">
          <span class="material-icons">arrow_forward_ios</span>
        </div>
      </div>
      <div class="no-data" v-if="!$fetchState.pending && 1 > programList.length">
        <i class="material-icons">error_outline</i>
        <p>데이터가 없습니다.</p>
      </div>
      <swiper v-else ref="programSwiper" class="program-swiper" :options="programSwiperOptions">
        <swiper-slide v-for="item in programList" :key="item.oid" @click.native="goToViewUrl( item )">
          <div class="thumb-area bg-white" :class="{ 'no-image': !$validate.isNotEmpty(item.thumbNailUrl) }">
            <img v-if="$validate.isNotEmpty( item.thumbNailUrl )" :src="item.thumbNailUrl"/>
            <img v-else src="~@/assets/images/portal/sample/no_image.png" class="no-img" alt="noImage"/>
          </div>
          <div class="txt-area">
            <span class="tit" v-text="item.name"/>
            <span class="label has-color" v-text="item.extraInfoMap.spaceOid.VALUE"/>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-program mob-visible"></div>
    </div>
  </div>
</template>
<script>

const URL_LIST_CENTER_PROGRAM = "/api/portlet/v1/portalPortletApi_mathList";

// 수리과학 도메인 url
const URL_MATH = process.env.SYSTEM.MATH.URL;

export default {
  name : "ThePortletProgramList",
  data() {
    return {

      // 수리과학정보 체험센터 리스트
      programList : [],

      // 페이지 사이즈
      pageSize : 10,

      // 썸네일 카운트 추가
      notThumbNailCount : 0,

      /** SWIPER 관련 */

      // check
      checkedCenterOid : "AREA0000001",

      // Swiper
      programSwiperOptions : {
        autoplay       : {
          delay                : 7000,
          disableOnInteraction : false,
        },
        slidesPerView  : 2,
        spaceBetween   : 16,
        slidesPerGroup : 1,
        navigation: {
          nextEl: ".swiper-program-next",
          prevEl: ".swiper-program-prev"
        },
        setWrapperSize : true,
        breakpoints: {
          1024: {
            slidesPerView: 2.6,
            slidesOffsetBefore: 24,
            slidesOffsetAfter: 20,
          },
          500: {
            slidesPerView: 2.24,
            spaceBetween: 18,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
        }
      },
    }
  },
  computed : {
    swiper() {
      return this.$refs.programSwiper.swiper
    },
  },
  watch : {

  },

  created() {
    console.log( "현재 env 설정은...." + process.env.NUXT_ENV_STAGE );
  },

  fetch() {
    this.getCenterProgramList( "AREA0000001" , this.pageSize );
  },

  methods : {

    /**
     * 공간 선택
     * @param {String} centerOid - AREA0000001 , AREA0000002 , AREA0000003
     * */
    changeSelectCenter( centerOid ){

      this.checkedCenterOid = centerOid;

      this.getCenterProgramList( centerOid , this.pageSize );
    },

    /**
     * Center MathProgramList를 가져옵니다.
     * @param centerOid
     * @param pageSize
     * */
    async getCenterProgramList ( centerOid , pageSize ){

      if( this.$validate.isEmpty( centerOid ) ){
        return;
      }

      let param = {
        "searchType" : centerOid,
        "pageSize"   : pageSize,
        "statusTypeFlag" : "USE",
      }

      await this.$axios.post( URL_LIST_CENTER_PROGRAM , param ).then( res => {

        if( this.$validate.isEmpty( res.data?.data ) ){
          return "";
        }
        let dataArray = res.data.data;
        dataArray.forEach( (item) => {

          if( this.$validate.isEmpty( item.extraInfoMap ) ){
            return "";
          }

          let itemSpaceOid = item.extraInfoMap.spaceOid;

          item.extraInfoMap.spaceOid = this.$constant.SPACE_OID_OBJECT[itemSpaceOid];

          item.thumbNailUrl = this.getThumbnailPath( item.thumbNailUrl );
        });

        this.programList = dataArray;

      });

    },

    /**
     * 상세보기 이동
     * */
    goToViewUrl( item ){

      if( this.$validate.isEmpty( item.linkViewUrl ) ){
        return "";
      }

      // 수리과학의 centerOid의 값에 따라 타입을 정해줍니다. ( 원주 : W, 춘천 : C, 동해 : D )
      const centerOid = item.extraInfoMap.centerOid;
      const centerType = this.$constant.CENTER_OID_OBJECT[centerOid].TYPE;

      let url = URL_MATH + "/math/sso/sso_login?location=" + item.linkViewUrl + "&centerType=" + centerType;

      window.open( url );

    },

    /**
     * 썸네일이 없을 경우 no-data 이미지를 가져옵니다.
     * @update 썸네일이 없을 경우 display하지 않는 것으로 수정
     * @update 썸네일 카운트 추가
     * */
    getThumbnailPath( thumbNail ){

      if ( this.$validate.isNotEmpty( thumbNail ) ){
        return thumbNail;
      }
      else{
        this.notThumbNailCount += 1
        return "";
      }

    },

    /**
     * 수리과학 메인 페이지로 이동
     * @param {String} centerOid
     * */
    goCenter(){

      const centerType = this.$constant.CENTER_OID_OBJECT[this.checkedCenterOid].TYPE;

      const defaultUrl = process.env.SYSTEM.MATH.URL + "/mathSciences/user/main/user_main?centerType=" + centerType;

      window.open( defaultUrl);
    },
  }
}
</script>
<style scoped>
</style>
